import { Box } from '@chakra-ui/react'
import FeedbackTable from './components/FeedbackTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <FeedbackTable />
    </Box>
  )
}
